export const moduleName = 'createOrganisation'

export type OrganisationType = 'organisation' | 'charity'

export type CreateOrganisationFormFields = {
  name: string
  hubspotId: string
  website?: string
  teamSize?: number
  contactName?: string
  email?: string
  phoneNumber?: string
  street?: string
  subStreet?: string
  town?: string
  postcode?: string
  region?: string
  associatedEmailDomains?: string[]
}

export type CreateCharityFormFields = Omit<CreateOrganisationFormFields, 'hubspotId'> & {
  hubspotId?: string
}

export type CreateOrganisationState = {
  organisation: CreateOrganisationFormFields
  charity: CreateCharityFormFields
}
